/* eslint-disable */
export const controlsBannerVideo = ({ element, video, ...params }) => {
	element.addEventListener('click', () => {
		const pauseSvg = /* html */
			`<svg xmlns="http://www.w3.org/2000/svg" class="opacity-80" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
			<path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
			<path d="M9 4h-2a2 2 0 0 0 -2 2v12a2 2 0 0 0 2 2h2a2 2 0 0 0 2 -2v-12a2 2 0 0 0 -2 -2z" stroke-width="0" fill="currentColor"></path>
			<path d="M17 4h-2a2 2 0 0 0 -2 2v12a2 2 0 0 0 2 2h2a2 2 0 0 0 2 -2v-12a2 2 0 0 0 -2 -2z" stroke-width="0" fill="currentColor"></path>
		</svg>`;
		const playSvg = /* html */
			`<svg xmlns="http://www.w3.org/2000/svg" class="opacity-80" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
			<path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
			<path d="M6 4v16a1 1 0 0 0 1.524 .852l13 -8a1 1 0 0 0 0 -1.704l-13 -8a1 1 0 0 0 -1.524 .852z" stroke-width="0" fill="currentColor"></path>
		</svg>`;
		const iconButton = element.querySelector('[ref="video-icon"]');
		const textButton = element.querySelector('[ref="video-text"]');
		if (video.paused) {
			video.play();
			iconButton.innerHTML = pauseSvg;
			textButton.innerHTML = textButton.dataset.playing;
		} else {
			video.pause();
			iconButton.innerHTML = playSvg;
			textButton.innerHTML = textButton.dataset.paused;
		}
	});
};